module.exports = __webpack_public_path__ + "static/media/step_005a.6ec0b35c.jpeg";